__turbopack_context__.v({
  "card": "style-module-scss-module__ZvOSHa__card",
});
